import { WarningIcon } from 'foundations-assets';
import { IconCircle } from 'foundations-components/transitional/components/IconCircle';
import { jsx as _jsx } from "react/jsx-runtime";
const ErrorIcon = () => /*#__PURE__*/_jsx(IconCircle, {
  backgroundColor: "icon-alert-default",
  borderWidth: "0",
  color: "icon-primary-on-fill-default",
  icon: WarningIcon,
  size: "100",
  padding: "100"
});
export default ErrorIcon;